export default __webpack_public_path__ + "static/media/ADD.25c02d92.svg";